import { Component } from '@angular/core';

import { TealiumUtagService } from '../tealium/utag.service';
import { MatTabGroup, MatTab } from '@angular/material/tabs';
import { LessonElementsComponent } from '../components/lesson-elements/lesson-elements.component';
import { LessonAnatomyComponent } from '../components/lesson-anatomy/lesson-anatomy.component';

@Component({
  selector: 'stars-lessons-page',
  templateUrl: './lessons.html',
  styleUrls: ['./lessons.scss'],
  providers: [TealiumUtagService],
  imports: [
    MatTabGroup,
    MatTab,
    LessonElementsComponent,
    LessonAnatomyComponent
  ]
})
export class LessonsPageComponent {}
